/**
 * Mapping env parameters to a json object for ease of use
 * or create variables for other parameters
 */
function getConfig() {
  const env = process.env.REACT_APP_ENV;
  if (env === 'dev') {
    return {
      ENV: env,
      BFF_URL: 'https://bff.dev.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      APIG_URL: 'https://z1ywic4az4.execute-api.eu-west-2.amazonaws.com/dev/',
      CLOUDFRONT_URL: 'https://d1fca218vcftx3.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-KWW6KW5',
      HELPJUICE_ACCOUNT_NAME: 'velaris',
      WEB_APP_URL: 'https://app.dev.velaris.io',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.dev.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.dev.velaris.io/',
    };
  }
  if (env === 'qa') {
    return {
      ENV: env,
      BFF_URL: 'https://bff.qa.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      APIG_URL: 'https://ny47mz6hdg.execute-api.eu-west-2.amazonaws.com/qa/',
      CLOUDFRONT_URL: 'https://d1lv5eu7b9fob8.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-KWW6KW5',
      HELPJUICE_ACCOUNT_NAME: 'velaris',
      WEB_APP_URL: 'https://app.qa.velaris.io',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.qa.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.qa.velaris.io/',
    };
  }
  if (env === 'stage') {
    return {
      ENV: env,
      BFF_URL: 'https://bff.stage.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      APIG_URL: 'https://96i5ovh886.execute-api.eu-west-2.amazonaws.com/stage/',
      CLOUDFRONT_URL: 'https://d1ynwxdve0rolc.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-KQBSQWH',
      HELPJUICE_ACCOUNT_NAME: 'velaris',
      WEB_APP_URL: 'https://app.stage.velaris.io',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.stage.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.stage.velaris.io/',
    };
  }
  if (env === 'prod') {
    return {
      ENV: env,
      BFF_URL: 'https://bff.euw1.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      APIG_URL: 'https://u72b8v3wy8.execute-api.eu-west-2.amazonaws.com/prod/',
      CLOUDFRONT_URL: 'https://d2f5ma9rui5lkz.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-T78XVJL',
      HELPJUICE_ACCOUNT_NAME: 'velaris',
      WEB_APP_URL: 'https://app.euw1.velaris.io',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.euw1.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.euw1.velaris.io/',
    };
  }
  if (env === 'perf') {
    return {
      ENV: env,
      APIG_URL: 'https://bff.perf.velaris.io/csm/v1/bff/',
      BFF_URL: 'https://bff.perf.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      CLOUDFRONT_URL: 'https://d3jkfa7x4949qb.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-KWW6KW5',
      HELPJUICE_ACCOUNT_NAME: 'velaris',
      WEB_APP_URL: 'https://app.perf.velaris.io',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.perf.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.perf.velaris.io/',
    };
  }
  if (env === 'local') {
    // change as needed during development
    return {
      ENV: 'dev',
      APIG_URL: 'https://bff.dev.velaris.io/csm/v1/bff/',
      BFF_URL: 'https://bff.dev.velaris.io/csm/v1/bff/', // NEVER EVER EVER USE THIS
      CLOUDFRONT_URL: 'https://d3tvclhcaufh70.cloudfront.net/',
      GTAG_MGR_ID: 'GTM-KWW6KW5',
      HELPJUICE_ACCOUNT_NAME: 'velaris-dev2',
      PUBLIC_ASSETS_URL: 'https://velaris-assets.dev.velaris.io/',
      PRIVATE_ASSETS_URL: 'https://private-assets.dev.velaris.io/',
      WEB_APP_URL: 'http://localhost:3000',
    };
  }
  throw new Error('Env not specified, can not fetch config');
}
const config = getConfig();

export default config;
